import { CheckoutTreeOverviewSchema } from "@redotech/redo-model/checkouts/checkout-tree";
import {
  ValidateCheckoutTreeTransformationError,
  ValidateCheckoutTreeTransformationWarning,
} from "@redotech/redo-model/checkouts/checkout-tree-transformation";
import * as z from "zod";

export const validateCheckoutTreeTransformation = {
  name: "validateCheckoutTreeTransformation" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({
    warnings: z.array(ValidateCheckoutTreeTransformationWarning),
    errors: z.array(ValidateCheckoutTreeTransformationError),
    currentCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
    proposedCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
  }),
};
export type ValidateCheckoutTreeTransformationOutput = z.infer<
  typeof validateCheckoutTreeTransformation.output
>;
